import parseColor from '../../../parseColor';
export function encode(color, siteColors) {
    if (color.name) {
        var wixColor = siteColors.find(function (c) { return c.name === color.name; });
        var rgbColor = parseColor(wixColor.value, color.opacity).rgb();
        return {
            opacity: color.opacity,
            rgba: rgbColor,
            color: {
                value: rgbColor,
                name: wixColor.name,
                reference: wixColor.reference,
            },
        };
    }
    return {
        opacity: color.opacity,
        rgba: parseColor(color.value, color.opacity).rgb(),
        color: false,
    };
}
export function decode(color, siteColors) {
    var _a;
    if (!color.value) {
        return null;
    }
    if (color.themeName) {
        var wixColor = siteColors.find(function (c) { return c.reference === color.themeName || c.name === color.themeName; });
        var parsedColor = parseColor(color.value || wixColor.value);
        if (wixColor) {
            return {
                value: parsedColor.rgb(),
                name: wixColor.name,
                opacity: parsedColor.opacity(),
            };
        }
    }
    var parsedOriginalColor = parseColor(color.value);
    return {
        value: parsedOriginalColor.rgb(),
        name: (_a = color.themeName) !== null && _a !== void 0 ? _a : null,
        opacity: parsedOriginalColor.opacity(),
    };
}
//# sourceMappingURL=WixStyleColors.js.map